namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_vk_lists, {

		Remove: {
			color: 'red',
		},

		Groups: {
			gap: $mol_gap.block,
			padding: {
				left: $mol_gap.block,
			},
		},

		Name: {
			padding: $mol_gap.text,
		},

		Main: {
			gap: $mol_gap.block,
			Content: {
				gap: $mol_gap.block,
				align: {
					items: 'flex-start'
				},
			},
		},

		List_head: {
			gap: $mol_gap.block,
		},

		List: {
			gap: $mol_gap.space,
		},

		Lists: {
			gap: '1.5rem',
		},
		
	} )
	
}
